import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { WaitlistModal } from '../components/WaitlistModal';
export function AboutPage() {
  const [isWaitlistOpen, setIsWaitlistOpen] = useState(false);
  return <div className="min-h-screen bg-[#FAFAFA]" data-id="element-89">
      <WaitlistModal isOpen={isWaitlistOpen} onClose={() => setIsWaitlistOpen(false)} data-id="element-90" />

      {/* Minimal Header */}
      <header className="border-b border-gray-200" data-id="element-91">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 h-20 flex items-center" data-id="element-92">
          <Link to="/" className="flex items-center text-gray-600 hover:text-gray-900 transition-colors group" data-id="element-93">
            <ArrowLeft className="w-5 h-5 mr-2 group-hover:-translate-x-1 transition-transform" data-id="element-94" />
            <span className="font-medium" data-id="element-95">Back</span>
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-3xl mx-auto px-6 sm:px-8 lg:px-12 py-24 sm:py-32 lg:py-40" data-id="element-96">
        <article className="space-y-10" data-id="element-97">
          {/* All paragraphs same size */}
          <p className="text-xl sm:text-2xl leading-relaxed text-gray-900 font-normal" data-id="element-98">
            We used to design for people. Now, we design for the AI that speaks
            to them.
          </p>

          <p className="text-xl sm:text-2xl leading-relaxed text-gray-900 font-normal" data-id="element-99">
            AI doesn't just search, it interprets. It connects context, tone,
            and data to decide what matters.
          </p>

          <p className="text-xl sm:text-2xl leading-relaxed text-gray-900 font-normal" data-id="element-100">
            Every conversation reflects the signals you send into the world.
            Unmanaged signals can leave you misrepresented, or simply invisible.
          </p>

          <p className="text-xl sm:text-2xl leading-relaxed text-gray-900 font-normal" data-id="element-101">
            That's why we're building{' '}
            <span className="font-semibold" data-id="element-102">Andoe</span>.
          </p>

          <p className="text-xl sm:text-2xl leading-relaxed text-gray-900 font-normal" data-id="element-103">
            An <span className="font-semibold" data-id="element-104">intelligence layer</span> that
            understands your business and helps you make data informed
            decisions.
          </p>

          {/* CTA */}
          <div className="pt-12 flex flex-col sm:flex-row gap-4" data-id="element-105">
            <Button variant="primary" className="px-5 py-2.5 text-sm" onClick={() => setIsWaitlistOpen(true)} data-id="element-106">
              Join Waitlist
            </Button>
            <Button variant="secondary" className="px-5 py-2.5 text-sm" onClick={() => window.open('https://www.linkedin.com/in/jason-jm-yang', '_blank')} data-id="element-107">
              Contact
            </Button>
          </div>
        </article>
      </main>
    </div>;
}